<template>
    <div class="attachment_list">
        <div class="attachment_content">
            <div class="tit">附件</div>
            <template v-if="attachmentList.length">
                    <el-card class="box-card" shadow="hover">
                        <div slot="header" class="doc_list_head">
                            <el-row :gutter="24">
                                <el-col :span="12"><span class="doc_name">附件名称</span></el-col>
                                <el-col :span="4"><span class="doc_name">上传人</span></el-col>
                                <el-col :span="4"><span class="doc_name">上传时间</span></el-col>
                                <el-col :span="4"><span class="doc_name">操作</span></el-col>
                            </el-row>
                        </div>
                        <div class="doc_item" v-for="doc in attachmentList" :key="doc.docId">
                            <el-row :gutter="24">
                                <el-col :span="12"><span class="doc_name"><i class="el-icon-document"></i> {{doc.fileName}}</span></el-col>
                                <el-col :span="4"><span class="doc_name">{{doc.createUser}}</span></el-col>
                                <el-col :span="4"><span class="doc_name">{{doc.createTime || '-'}}</span></el-col>
                                <el-col :span="4">
                                    <el-button type="text" v-if="!isClosed && mediatorState && !isManage" @click="deletefile(doc)">删除</el-button>
                                    <el-button type="text" @click="downfile(doc,false)">下载</el-button>
                                    <el-button type="text" @click="preview(doc,false)">预览</el-button>
                                </el-col>
                            </el-row>
                        </div>
                    </el-card>
            </template>
            <template v-else>
                <el-card class="box-card" shadow="hover">
                    <div class="text item">暂无附件</div>
                </el-card>
            </template>
        </div>
        <div class="attachment_foot">
            <el-button v-if="!isClosed && !isManage" type="primary" style="margin-top: 40px" @click="dialogVisible = true">上传附件</el-button>
        </div>
        <el-dialog class="doc_send_dialog" title="上传附件" width="880px" :close-on-click-modal=false :visible.sync="dialogVisible" :append-to-body="true" center>
            <div class="doc_send_wrap">
                <el-form :model="docsendForm" ref="docsendForm" label-position="left" label-width="100px" size="small" :hide-required-asterisk="true">
                    <el-form-item label="选择文件" prop="fileName" v-for="(item, index) in docsendForm.fileList" :key="index">
                        <el-row>
                            <el-col :span="20">
                                <el-upload class="upload-doc" :ref="'upload_' + item.index" :action="fileUploads.actionUrl" :disabled="item.fileInfo != null" :accept="fileUploads.acceptType" :headers="fileUploads.flk" :on-change="function (file, fileList){return handleChange(file, fileList, item)}" :http-request="handleRequestRecord" :show-file-list="false" :auto-upload="false">
                                    <el-input :ref="'input_' + item.index" v-model="item.fileName" clearable placeholder="点击上传文件" @clear="handleClearFile(item)" @focus="selectFile(item)" maxlength="50" ></el-input>
                                </el-upload>
                            </el-col>
                            <el-col :span="4" class="operate_buttons">
                                <el-button type="text" icon="el-icon-circle-plus-outline" v-if="index==docsendForm.fileList.length-1" @click="addItem"></el-button>
                                <el-button type="text" icon="el-icon-circle-plus-outline" v-else style="visibility: hidden"></el-button>
                                <el-button type="text" icon="el-icon-remove-outline" v-if="docsendForm.fileList.length>1" style="color: red" @click="deleteItem(index)"></el-button>
                            </el-col>

                        </el-row>
                    </el-form-item>
                    <div class="el-upload__tip">只能上传pdf/doc/docx/png/jpg/xls/xlsx文件，{{maxFileTip}}</div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog(null)">取 消</el-button>
                <el-button type="primary" :loading="BtnLoading" @click="handleSendBook()">发送</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import {gzzcUpLoadDoc, queryOtherDocList, delDocAndAttach} from "../../../api/casespace";
    import {getStore,dateformat} from '@/utils/utils.js'
    import config from '@/config/config.js'
    import filedownload from '@/api/filedown.js'
    import {maxFileLength, maxFileWarning, maxFileTip, isManageRole} from "../../../utils/utils";

    export default {
        name: "",
        data() {
            return {
                docsendForm: {
                    fileList:[{
                        index: 1,
                        fileName: '',
                        fileInfo: null,
                    }]
                },
                uploadRefIndex: 1,
                attachmentList: [],
                maxFileTip: maxFileTip,
                fileUploads: {
                    actionUrl: `${config.baseURL}/gzzc/docBook/upload`,
                    // acceptType: '.pdf,.doc,.docx',
                    acceptType: '.pdf,.doc,.docx,.png,.jpg,.xls,.xlsx',
                    flk: {
                        JWTToken: getStore('flk'),
                        appName: config.appName,
                        cType: 'PC'
                    },
                    fileData: {
                        isView: 'NOVIEW'
                    },
                    fileList: "",
                    fileJson: []
                },
                isManage: false, // 管理员角色
                mediatorState: false,
                dialogVisible: false,
                BtnLoading: false,
                isClosed: localStorage.getItem('CloseState') == 'true' ? true : false,
            }
        },
        created() {
            this.getDocList()
        },
        mounted() {
            let loginInfouser = JSON.parse(getStore('loginInfo'));
            this.isManage = isManageRole(loginInfouser.userRoles)
            if (loginInfouser.hasOwnProperty('personType') && loginInfouser.personType == 'STAFF') {
                this.mediatorState = true
            }
        },
        methods: {
            getDocList() {
                let curUserSign, needSign, needSignArray = []
                this.workerDocumentList = []
                let groupList = []
                queryOtherDocList(this.$route.query.meetingid).then(res => {
                    if (res.data.code === 1000) {
                        let resData = res.data.data
                        resData.forEach(item => {
                            item.createTime = dateformat(new Date(item.createTime), 'yyyy-MM-dd hh:mm:ss')
                        })
                        this.attachmentList = resData
                    }
                })
            },
            addItem() {
                this.docsendForm.fileList.push({
                    index: this.uploadRefIndex++,
                    fileName: '',
                    fileInfo: null,
                })
            },
            deleteItem(index) {
                this.docsendForm.fileList.splice(index, 1)
            },
            uploadBlur(item) {
                let refName = 'input_' + item.index
                if (this.$refs[refName]) {
                    this.$refs[refName][0].blur();
                }
            },
            handleRequestRecord() {

            },
            handleChange(file, fileList, item) {
                if (file.size > maxFileLength) {
                    this.$message({
                        type: 'warning',
                        message: maxFileWarning
                    });
                    return false
                }
                let tempRet = /\.[^.]+$/.exec(file.name)
                let isAcceptType = true
                if (tempRet) {
                    if (!~this.fileUploads.acceptType.indexOf(tempRet[0])) {
                        isAcceptType = false
                    }
                }
                if (!isAcceptType) {
                    this.$message({
                        type: 'warning',
                        message: '文件只支持' + this.fileUploads.acceptType + '等格式'
                    });
                    fileList.pop()
                    return
                }
                if (tempRet.index > 20) {
                    this.$message({
                        type: 'warning',
                        message: '文件名不超过20个字符长度'
                    })
                    return false
                }

                item.fileName = file.name
                item.fileInfo = file.raw
                let refName = 'upload_' + item.index
                this.$refs[refName][0].submit();
            },
            handleClearFile(item) {
                console.log('handleClearFile')
                let refName = 'upload_' + item.index
                item.fileInfo = null
                item.fileName = ''
                if (this.$refs[refName] && this.$refs[refName].length) {
                    this.$refs[refName][0].clearFiles()
                }
            },
            closeDialog() {
                this.docsendForm.fileList =[{
                        index: 1,
                        fileName: '',
                        fileInfo: null,
                }]
                this.dialogVisible = false
            },
            selectFile(item) {
                if (item.fileName == '') {
                    let refName = 'input_' + item.index
                    if (this.$refs[refName]) {
                        this.$refs[refName][0].blur()
                    }
                }
            },
            handleSendBook() {
                let self = this
                let param = new FormData(), index = 0
                param.append(`meetingId`, this.$route.query.meetingid)
                for (let i=0; i<this.docsendForm.fileList.length; i++) {
                    let item = this.docsendForm.fileList[i]
                    if (item.fileInfo) {
                        param.append(`files[${index}].fileName`, item.fileName || item.fileInfo.name)
                        param.append(`files[${index}].uploadFile`, item.fileInfo)
                        param.append(`files[${index}].docType`, 'GZZC_OTHERS')
                        index ++
                    } else {
                        this.$message.error('请点击上传附件')
                        return
                    }
                }
                this.BtnLoading = true
                gzzcUpLoadDoc(param).then(res => {
                    this.BtnLoading = false
                    if (res.data.code === 1000) {
                        this.closeDialog()
                        this.$message.success('发送成功')
                        this.getDocList()
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).catch(error => {
                    this.BtnLoading = false
                })
            },
            downfile(doc, type) {
                if (type) {
                    filedownload('/gzzc/docBook/clerkRecordDownload', {
                        fileId: doc.attachFileId,
                        id: doc.attachId
                    }, doc.attachFileName)
                } else {
                    filedownload('/gzzc/docBook/clerkRecordDownload', {
                        fileId: doc.fileId,
                        id: doc.id
                    }, doc.fileName)
                }
            },
            preview(doc, type) {
                if (type) {
                    window.open(config.baseURL + '/gzzc/docBook/previewImg/' + doc.attachFileId)
                } else {
                    window.open(config.baseURL + '/gzzc/docBook/previewImg/' + doc.fileId)
                }
            },
            deletefile(doc) {
                let params = {documentId : doc.docId, attachId: doc.id}
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                delDocAndAttach(params).then(res => {
                    loading.close()
                    if (res.data.code === 1000) {
                        this.$message.success('已成功删除')
                        // 刷新列表
                        this.getDocList()
                    } else {
                        this.$message('删除失败')
                    }
                    console.log(res)
                }).catch(err => {
                    loading.close()
                    this.$message('删除失败')
                    console.log(err)
                })
                console.log(doc)
            },
        }
    }
</script>

<style scoped lang="scss">
.attachment_list {
    margin: 26px 40px 20px 65px;

    .attachment_content {
        .box-card {
            margin-bottom: 12px;
            .doc_list_head {
                .doc_name {
                    font-size: 16px;
                }
            }
        }

        padding-bottom: 40px;

        .tit {
            font-size: 20px;
            color: #333333;
            position: relative;
            padding-left: 12px;
            margin-bottom: 30px;

            &:before {
                position: absolute;
                content: '';
                width: 4px;
                height: 20px;
                background-color: #1e6dcb;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }

        .el-card__header {
            padding: 10px 20px;
            background-color: #f8f9fa;

            span {
                font-size: 14px;
            }
        }

        .doc_item {
            line-height: 32px;

            .doc_name {
                font-size: 14px;
            }

            .el-tag {
                margin-right: 8px;
            }
        }
    }

    .docSign_foot {
        text-align: center;

        .el-button {
            color: #fff;
        }
    }

    .docSign_foot_block {
        width: 100%;
        height: 80px;
        margin-top: 20px;
        font-size: 16px;
        border-top: 1px solid #EBEEF5;
        display: flex;
        align-items: center;

        .left {
            margin-left: 10px;
        }

        .resign {
            margin-left: 20px;
            text-decoration: underline;
            color: #1e6dcb;
            cursor: pointer;
        }

        .signImg {
            width: 120px;
            margin-left: 10px;
        }
    }

    .attachment_foot {
        text-align: center;

        .el-button {
            color: #fff;
        }
    }
}
.doc_send_dialog {
    .el-dialog__body {
        padding: 25px 25px 0;
    }

    .doc_send_wrap {
        margin: 0 25px;
        .upload-doc {
            /deep/ .el-upload {
                width: 100%;
                text-align: left;
            }
        }
        .operate_buttons {
            display: flex;
            .el-button {
                margin-left: 16px;
                font-size: 30px;
                padding-top: 0;
                padding-bottom: 0;
            }
        }

        .doc_type {
            width: 100%;
        }
    }

    .dialog-footer {
        padding-bottom: 20px;

        .el-button {
            width: 120px;
            height: 40px;
        }
    }

    .el-button+.el-button {
        margin-left: 40px;
    }

    .el-dialog {
        margin-top: 5vh !important;
    }
}

</style>
